/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {
    alternative: { type: 'variant', values: [ true ] },
    disabled: { type: 'variant', values: [ true ] },
    focus: { type: 'variant', values: [ true ] },
    hover: { type: 'variant', values: [ true ] },
    pressed: { type: 'variant', values: [ true ] }
  },
  rules: [
    {
      if: { alternative: true },
      tokens: { paddingBottom: 8, paddingTop: 8 }
    },
    {
      if: { hover: true },
      tokens: { inputBackgroundColor: '#efefef' }
    },
    {
      if: { disabled: true },
      tokens: { inputBackgroundColor: '#efefef', textColor: '#c9c8c8' }
    },
    { if: { focus: true }, tokens: { inputBorderWidth: 3 } }
  ],
  tokens: {
    fontSize: 16,
    inputBackgroundColor: '#ffffff',
    inputBorderColor: '#666666',
    inputBorderWidth: 1,
    inputWidth: 64,
    lineHeight: 1.5,
    padding: 12,
    paddingBottom: 12,
    paddingLeft: 12,
    paddingRight: 12,
    paddingTop: 12,
    textColor: '#000000'
  }
}
export default theme
